{
  "version": 1,
  "asset_id": "4930e9c9-f63f-4142-88d8-fbd8695b9a5a",
  "project_id": "1e2975bf-5ed0-490a-887a-32746528c0b1",
  "url": "/__l5e/assets-v1/4930e9c9-f63f-4142-88d8-fbd8695b9a5a/mesoject-gun.webp",
  "r2_key": "a/v1/1e2975bf-5ed0-490a-887a-32746528c0b1/4930e9c9-f63f-4142-88d8-fbd8695b9a5a/mesoject-gun.webp",
  "original_filename": "mesoject-gun.webp",
  "size": 29528,
  "content_type": "image/webp",
  "created_at": "2026-09-21T21:17:10Z"
}
